var map = {
	"./checkin.png": 280,
	"./day1checkin.png": 281,
	"./day2checkin.png": 282,
	"./kit.png": 283,
	"./lunch.png": 284,
	"./vipkit.png": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;


//////////////////
// WEBPACK FOOTER
// ./static/img/scenario ^\.\/.*\.png$
// module id = 279
// module chunks = 1